import React, { useEffect, useState, useRef } from "react";
import "./xpressNewOrderPopup.css";
import moment from "moment";
import notificationBell from "./notificationBell.mp3";

const IOS = /Macintosh|iPad|iPhone/i.test(navigator.userAgent);

const XpressNewOrderPopUp = ({ xpressData, setShowConfirmPopup, setOrder }) => {
  const audioRef = useRef(IOS ? null : new Audio(notificationBell));

    useEffect(() => {
        const audio = audioRef.current;

        if (!IOS && xpressData?.NEW?.length > 0) {
            if (Notification.permission.toUpperCase() === "GRANTED") {
                audio.loop = true;
                audio.play().catch((err) => console.warn("Autoplay blocked:", err));

            } else if (Notification.permission.toUpperCase() !== "GRANTED") {
                Notification.requestPermission();
            }
        }

        return () => {
            if (!IOS && audio) {
                audio.pause();
                audio.currentTime = 0;
            }
        };
    }, [xpressData.NEW, IOS]);

  return (
    <div className="xpressContainer">
      {xpressData?.NEW?.length > 0 &&
        xpressData?.NEW?.map((order, index) => {
          const [startTime, endTime] = order.deliverBy
            .split(" - ")
            .map(
              (time) => time.trim().split(" ")[0] + " " + time.split(" ")[1]
            );

          const startMoment = moment(startTime, "hh:mm A");
          const endMoment = moment(endTime, "hh:mm A");

          const difference = endMoment.diff(startMoment, "minutes");
          const formattedDate = moment(order.deliveryDate).format(
            "dddd, Do MMM"
          );

          return (
            <div className="xpress-new-order-popup" key={index}>
              <div className="popup-content">
                <div className="notification">
                  <span className="icon">🔔</span>
                  <span>New Order!</span>
                </div>
                {order?.orderedItems?.map((item, i) => (
                  <div className="itemName" key={i}>
                    <p>
                      {item.quantity}
                      <span> {item.menuName}</span>
                    </p>
                    <strong> {item.itemType}</strong>
                  </div>
                ))}
                <p>📍 {order.craverDetails.craverAddress}</p>
                <p className="mt-1">Distance: {order.distance}</p>
                {difference === 60 ? (
                  <div>
                    <p className="mt-1 mb-0">Deliver By:</p>
                    <p className="mt-0 mb-0">
                      <strong>
                        {order.deliverBy} - {formattedDate}
                      </strong>
                    </p>
                  </div>
                ) : null}
                <div className="popup-actions">
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      if (!IOS) {
                        audioRef.current?.play();
                      }
                      setOrder(order);
                    }}
                  >
                    Accept
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      setOrder(order);
                      setShowConfirmPopup(true);
                    }}
                  >
                    Decline
                  </button>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default XpressNewOrderPopUp;
